import {
  fetchUsersByRoleListRoutine,
  fetchUsersListRoutine,
  getUserRoleLogsRoutine
} from 'modules/users/ducks/actions'

const defaultState = {
  list: [],
  listByRoles: {},
  pagination: null,
  logs: [],
  isLoading: false,
  isLoadingLogs: false
}

const usersReducer = (state = defaultState, action) => {
  switch (action.type) {
    case fetchUsersListRoutine.TRIGGER:
      return {
        ...state,
        isLoading: true
      }
    case fetchUsersListRoutine.FAILURE:
      return {
        ...state,
        isLoading: false
      }
    case fetchUsersListRoutine.SUCCESS:
      return {
        ...state,
        list: action.payload.data,
        pagination: {
          itemsCount: action.payload.meta.total,
          totalPages: action.payload.meta.lastPage,
          perPage: action.payload.meta.perPage,
          currentPage: action.payload.meta.currentPage
        },
        isLoading: false
      }
    case fetchUsersByRoleListRoutine.SUCCESS:
      return {
        ...state,
        listByRoles: action.payload
      }
    case getUserRoleLogsRoutine.TRIGGER:
      return {
        ...state,
        isLoadingLogs: true
      }
    case getUserRoleLogsRoutine.FAILURE:
      return {
        ...state,
        isLoadingLogs: false
      }
    case getUserRoleLogsRoutine.SUCCESS:
      return {
        ...state,
        logs: action.payload.data,
        isLoadingLogs: false
      }
    default:
      return state
  }
}

export default usersReducer
